import React, { Fragment, useEffect, useRef, useState } from 'react';
import { FnAxios, Convert, undefinedOrNull, I18n, Extension, ParseHtml} from "utilities/utilities";
import { ApiProject } from "enum/api";
import { Card, Grid, Typography } from '@mui/material';
import usePagination from 'components/Pagination/Pagination';
import { Pagination, Stack, } from '@mui/material';
import PaginationItem from "@mui/material/PaginationItem";
import AccordionCustom from 'components/Accordion';
import { EnumProjectColorStatusHistory } from 'enum/enum';
import "./HistoryProject.css";
import { FormProvider, useForm } from 'react-hook-form';
import UploadFileItem from 'components/Input/UploadFile';
export interface IPropsLogHistory{
    nRefID: number;
    nMode: number;
}

const LogHistory = (props: IPropsLogHistory) => {
    const AxiosFn = FnAxios();
    const [nRefID, setnRefID] = useState(null);
    const [lstDetailsLogHistory, setlstDetailsLogHistory] = useState([]);

    useEffect(() => {
        if (props.nRefID) {
            setnRefID(props.nRefID);
            GetLogHistoryProject(props.nRefID);
        }
    }, [props.nRefID]);

    const GetLogHistoryProject = (nRefID) => {
        let objParam = {
            // nRefID: undefinedOrNull(sRefID, "number"),
            nRefID: Convert.StringToInt(nRefID),
            nMode: props.nMode,
        }
        AxiosFn.Get(ApiProject.GetLogHistory, objParam, (result) => {
            setlstDetailsLogHistory(result.lstDetailsLogHistory ?? []);
        });
    }

    const form = useForm({
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
    });
    const onClearFile = useRef(null);

    //#region Page All
    const PER_PAGE = 5;
    let [page, setPage] = useState(1);
    const count = Math.ceil(lstDetailsLogHistory.length / PER_PAGE);
    const _DATA = usePagination(lstDetailsLogHistory, PER_PAGE);

    const handleChange = (e, p) => {
        setPage(p);
        _DATA.jump(p);
        // window.scrollTo(0, 800);
    };

    const pageNext = () => {
        return <>{`${I18n.SetText("Project.sNext")}`}</>;
    };

    const pagePrevious = () => {
        return <>{`${I18n.SetText("Project.sPrevious")}`}</>;
    };
    //#endregion

    return (
        <Grid item container xs={12} md={12} spacing={1} style={{ paddingBottom: '1%', }}>
            <Grid item xs={12} md={12} style={{ paddingBottom: '1%', }}>
                <Grid item className='div-breadcrumbs-Project'>
                    <Typography variant="h6" style={{ fontSize: 'large', }}>{`${I18n.SetText("Project.sOperationHistory")}`}</Typography> 
                </Grid>
            </Grid>
            <Grid item xs={12} md={12}>
                {_DATA.currentData().length > 0 ?
                    <>
                        <Grid item container spacing={2} xs={12} md={12} direction="row" justifyContent={"center"} alignItems={"center"} style={{ paddingLeft: '0px' }}>
                            {(_DATA.currentData()).map((iLogHistory, index) => {
                                let _sColor = iLogHistory.sColor ?? "#bbbbbb"; 
                                // sColorType > 1 = เขียว, 2 = ส้ม, 3 = ฟ้า, 4 = แดง, 5 = เหลือง, 6 = ม่วง
                                
                                switch(iLogHistory.sColorType)
                                {
                                    case "1": 
                                        _sColor = EnumProjectColorStatusHistory.Green; //เขียว
                                        break;
                                    case "2":  
                                        _sColor = EnumProjectColorStatusHistory.Orange; //ส้ม
                                        break;
                                    case "3": 
                                        _sColor = EnumProjectColorStatusHistory.Blue; //ฟ้า
                                        break;                                   
                                    case "4": 
                                        _sColor = EnumProjectColorStatusHistory.Red; //แดง
                                        break;
                                    case "5":
                                        _sColor = EnumProjectColorStatusHistory.Yellow; //เหลือง
                                        break;
                                    case "6":
                                        _sColor = EnumProjectColorStatusHistory.Purple; //ม่วง
                                        break;
                                }

                                return (
                                    <Grid item xs={12} style={{ borderBottom: "10%" }} key={"LogHistory_" + iLogHistory.nLogID + "_" + index}>
                                        <AccordionCustom
                                            header={iLogHistory.sTitle}
                                            isExpanded={false}
                                            color="#0a0a0a"
                                            bgColor="rgb(102,151,245)"
                                            background={_sColor}
                                            expandIconColor="rgb(112 112 112)"
                                            borderColor="white"
                                            borderRadius="20px !important"
                                            boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
                                            boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
                                        >
                                            <Grid item xs={12} md={12} container spacing={1}>
                                                <Grid item xs={12} md={12} container spacing={1}>
                                                    <Grid item xs={12} md={1}>
                                                        <Typography variant="body1" >{`${I18n.SetText("Project.sComment")}`}</Typography> 
                                                    </Grid>
                                                    <Grid item xs={12} md={11}>
                                                        <Typography variant="body1" >{ParseHtml(iLogHistory.sComment ?? " - ")}</Typography> 
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12} md={12} container spacing={1}>
                                                    <Grid item xs={12} md={1}>
                                                        <Typography variant="body1" >{`${I18n.SetText("Project.sFile")}`}</Typography> 
                                                    </Grid>
                                                    {(iLogHistory.lstFileDocument || []).length === 0 ?
                                                        <Grid item xs={12} md={1}>
                                                            <Typography variant="body1" >{" - "}</Typography> 
                                                        </Grid>
                                                        :
                                                        <Grid item xs={12} md={10}>
                                                            <FormProvider {...form}>
                                                                <UploadFileItem
                                                                    required={false}
                                                                    modeDisplay={"list"}
                                                                    id={"oFileDocument"}
                                                                    name={"oFileDocument"}
                                                                    key={1}
                                                                    IsDrag={false}
                                                                    arrFile={iLogHistory.lstFileDocument}
                                                                    setarrFile={(e)=> { iLogHistory.lstFileDocument = e; }}
                                                                    Extension={[...Extension.PDF,Extension.Image_New,Extension.Word,Extension.Other]}
                                                                    IsFolder={false}
                                                                    isFileChange={true}
                                                                    IsMultiple={true}
                                                                    onClearFile={onClearFile}
                                                                    sFolderTemp="Project"
                                                                    nLimitFile={30}
                                                                    sLimitFile="MB"
                                                                    sPositionText="right"
                                                                    IsMultiDelete={false}
                                                                    disabled={true}
                                                                    IsHide={true}
                                                                />
                                                            </FormProvider>
                                                        </Grid>
                                                    }
                                                </Grid>
                                            </Grid>
                                        </AccordionCustom>                                        
                                    </Grid>
                                );        
                            })}
                        </Grid>
                        <Grid item xs={12}>
                            <Stack spacing={2} style={{ margin: "1rem auto 2rem", alignItems: "center" }}>
                                <Pagination
                                    count={count}
                                    page={page}
                                    onChange={handleChange}
                                    color="primary"
                                    renderItem={(item) => <PaginationItem components={{ previous: pagePrevious, next: pageNext }} {...item} />}
                                />
                            </Stack>
                        </Grid>
                    </>
                : 
                    <Grid item container spacing={2} xs={12} md={12} style={{ textAlign: 'center' }}>
                        <Grid item xs={12} md={12}>
                            <Card style={{ backgroundColor: "rgb(245 245 245)" }}>
                                <Typography style={{ margin: "3%" }}>{`${I18n.SetText("Project.sNoInformation")}`}</Typography>
                            </Card>
                        </Grid>
                    </Grid>
                }
            </Grid>                
        </Grid>
    )
}
export default LogHistory;